import {
	IRectangleTransformParameterPropsJsonSchema,
	type IRectangleTransformParameterProps,
} from "@shapediver/viewer.shared.types";

export const ParameterRectangleTransformComponentThemeDefaultPropsSchema =
	IRectangleTransformParameterPropsJsonSchema;

/**
 * @docAttached
 * @category entity
 * @configPath themeOverrides.components.ParameterRectangleTransformComponent.defaultProps
 * @displayName ParameterRectangleTransformComponent
 */
export interface ParameterRectangleTransformComponentThemeDefaultProps extends IRectangleTransformParameterProps {}
